// extracted by mini-css-extract-plugin
export default {"verticalStack":"style--verticalStack--010c3f"};